module.exports = __webpack_public_path__ + "assets/icon-cancel-selected.a5eb2849.svg";